import PublishFeature from './PublishFeature';

export default PublishFeature;
